import { render, staticRenderFns } from "./DataAmount.vue?vue&type=template&id=1f07d428&scoped=true&"
import script from "./DataAmount.vue?vue&type=script&lang=js&"
export * from "./DataAmount.vue?vue&type=script&lang=js&"
import style0 from "./DataAmount.vue?vue&type=style&index=0&id=1f07d428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07d428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
